import { useQuery } from '@tanstack/react-query';
import { SCHOOLYEARS_KEY } from './useSchoolyears';
import request from '@teetsh/app/src/utils/request';
import { deserializeSchoolyear } from '@teetsh/app/src/queries/schoolyears/serializer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

function getSchoolyear(
  schoolyearId: string,
  withSchools: boolean,
  updateLastAccessed: boolean,
  tz: string,
) {
  const baseUrl = `/schoolyears/${schoolyearId}`;
  const params = new URLSearchParams();
  if (withSchools) {
    params.append('include', 'schools');
  }
  if (updateLastAccessed) {
    params.append('update-last-accessed', 'true');
  }
  return request(`${baseUrl}?${params.toString()}`, {
    method: 'GET',
  }).then(res => deserializeSchoolyear(res, tz));
}

export default function useSchoolyear(
  schoolyearId: string,
  withSchools: boolean,
  updateLastAccessed: boolean,
) {
  const user = useUser();
  return useQuery({
    queryKey: [SCHOOLYEARS_KEY, schoolyearId, { withSchools }],
    queryFn: () =>
      getSchoolyear(
        schoolyearId,
        withSchools,
        updateLastAccessed,
        user.location,
      ),
    refetchOnWindowFocus: false,
  });
}
